import { useMutation, useQueryClient } from '@tanstack/react-query';

import { acknowledgeAllFlags, acknowledgeFlag } from '../../lib/api/endpoints';

import { flagKeys } from './queries';

export function useAcknowledgeFlag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: acknowledgeFlag,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: flagKeys.all });
    },
  });
}

export function useAcknowledgeAllFlags() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: acknowledgeAllFlags,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: flagKeys.all });
    },
  });
}
